export default {
    videoNotLoaded: "Video im Browser nicht verfügbar",
    next: "Weiter",
    previous: "Zurück",
    skipAll: "Alle überspringen",
    finish: "Fertigstellen",
    skipTutorial: "Tutorial überspringen",
    startTutorial: "Tutorial starten",
    welcome: {
        title: "Willkommen an Bord!",
        subtitle:
            "Diese kurze Anleitung dauert nur 2 Minuten und hilft dir, dich in wenigen Schritten mit der Plattform vertraut zu machen.",
        describe:
            "Es ist eine virtuelle Welt, in der Teams sich treffen, sprechen und natürlich zusammenarbeiten.",
        describe2: " — genau wie im echten Leben.",
        describe3: "In diesem Tutorial lernst du:",
        bloc1: "Dich bewegen",
        bloc2: "Mit anderen sprechen",
        bloc3: "Interaktive Objekte entdecken",
    },
    step1: {
        title: "Erkunde deine Welt",
        use: "Benutze deine",
        arrowkeys: " Pfeiltasten",
        or: "oder",
        wasd: "WASD, um deinen Avatar zu bewegen",
        aroundTheMap: "auf der Karte. Probiere es jetzt aus!",
        tip: "Tipp:",
        describeTip:
            "Halte die Umschalttaste beim Bewegen gedrückt, um schneller zu laufen — perfekt, wenn du spät dran bist oder schneller erkunden möchtest!",
        silentZone: "Du befindest dich gerade in einer Silent Zone — hier kann dich niemand hören.",
    },
    step2: {
        title: "Sprechen & Zusammenarbeiten",
        describe: "Um ein Gespräch zu beginnen, gehe auf jemanden zu ",
        describe2: " — Video oder Audio startet automatisch.",
        describe3:
            "Klicke auf das Vorhängeschloss-Symbol, um das Gespräch zu sperren und privat zu machen.",
        describe4:
            "Klicke während eines Gesprächs auf „Bildschirm teilen“, um deinen Bildschirm zu zeigen",
    },
    step3: {
        title: "Entdecken & Interagieren",
        interact: "Interagiere mit Objekten ",
        likeSign: "wie Schildern, Bildschirmen, Dokumenten und Portalen",
        sometimes: "— manchmal leuchten sie ",
        closer: "wenn du näher kommst.",
        describe3:
            "Versammle Personen in Besprechungsräumen, um spontane Diskussionen und Teamarbeit zu fördern.",
        describe4:
            "Mache eine Pause in Silent Zones, dem perfekten Ort, um dich zu konzentrieren und ungestört zu arbeiten.",
    },
};
